import React from 'react';
import * as PropTypes from 'prop-types';
import { TitleWrapper, Line, ChildrenPadding } from './elements';

type LineHeaderProps = {
  className?: string;
  children?: React.ReactNode;
};

function LineHeader({
  className,
  children,
}: LineHeaderProps): React.ReactElement {
  return (
    <TitleWrapper className={className}>
      <Line />
      <ChildrenPadding>{children}</ChildrenPadding>
      <Line />
    </TitleWrapper>
  );
}

LineHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default LineHeader;
